import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {ResourcesModuleIcon, CircleIcon} from '@csrc/assets/icons'

export const resourcesNavigation = [
	{
		id: 'wb.resources',
		title: 'resources.nav.resources',
		icon: <FontAwesomeIcon icon={ResourcesModuleIcon}/>,
		children: [
			// {
			// 	id: 'wb.resources.sites',
			// 	title: 'resources.nav.sites',
			// 	icon: <Circle size={12} />,
			// 	navLink: '/resources/sites/list',
			// 	action: 'call',
			// 	resource: 'RES_MANAGE_SITES'
			// },
			// {
			// 	id: 'wb.resources.site-structures',
			// 	title: 'resources.nav.siteStructures',
			// 	icon: <Circle size={12} />,
			// 	navLink: '/resources/site-structures/list',
			// 	action: 'call',
			// 	resource: 'RES_MANAGE_SITES'
			// },
			{
				id: 'wb.resources.globalLists',
				title: 'resources.nav.globalLists',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/resources/global-lists',
				featureKey: 'ckl_global_list',
				action: 'call',
				resource: 'RES_MANAGE_GLOBAL_LISTS|RES_VIEW_GLOBAL_LISTS'
			},
			{
				id: 'wb.resources.filemanager',
				title: 'resources.nav.filemanager',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/resources/filemanager',
				action: 'call',
				resource: 'RES_MANAGE_FILE_MANAGER'
			}
		]
	}
]
